(() => {
  angular
    .module('gm.common.content')
    .factory('GmyContent', GmyContent);

  function GmyContent(
    $timeout,
    GmyWordpressApi,
    Config
  ) {
    'ngInject';

    const pageConfig = {
      perPage: 8,
      offset: 0,
      embed: true
    };

    let preloadComplete = false;

    return {
      getArticle,
      getCategories,
      getCategoryBySlug,
      getFeaturedPosts,
      getLatestPosts,
      getPageBySlug,
      getPosts,
      isPreloadComplete,
      preload,
    };

    function getArticle(config) {
      return GmyWordpressApi.getPostBySlug(config.slug, config.type, true);
    }

    function getCategories(config) {
      return GmyWordpressApi.getCategories(config.type, config.cache);
    }

    function getCategoryBySlug(config) {
      return GmyWordpressApi.getCategoryBySlug(
        angular.extend(
          {},
          pageConfig,
          {
            offset: (pageConfig.perPage * config.page) - pageConfig.perPage
          }
        ),
        config.slug,
        config.type,
        true
      );
    }

    function getFeaturedPosts(config) {
      return GmyWordpressApi.getFeaturedPosts(config.id, config.type, true);
    }

    function getLatestPosts(config) {
      const configExtend = {
        perPage: config.perPage
      };

      if (config.categories) {
        configExtend.categories = config.categories;
      }

      return GmyWordpressApi
        .getPosts(
          angular.extend({}, pageConfig, configExtend),
          config.type,
          true
        );
    }

    function getPageBySlug(config) {
      return GmyWordpressApi.getPageBySlug(config.slug, config.type, config.cache);
    }

    function getPosts(config) {
      return GmyWordpressApi.getPosts(
        angular.extend(
          {},
          pageConfig,
          {
            offset: (pageConfig.perPage * config.page) - pageConfig.perPage
          }
        ),
        config.type
      );
    }

    function isPreloadComplete() {
      return preloadComplete;
    }

    function preload() {
      const contentPromises = [
        getCategories({
          type: 'news',
          cache: true
        }),
        getPosts({
          type: 'news',
          page: 1
        }),
        GmyWordpressApi.getPosts({
          perPage: 8,
          offset: 0,
          embed: true
        }, 'media', true),
      ];

      function processPromise(promiseIndex) {
        let localPromiseIndex = promiseIndex;
        contentPromises[localPromiseIndex]
          .then(() => {
            localPromiseIndex += 1;

            if (localPromiseIndex < contentPromises.length) {
              $timeout(() => {
                processPromise(localPromiseIndex);
              }, Config.preload.delay);
            }
            preloadComplete = true;
          });
      }

      if (Config.preload.enabled) {
        processPromise(0);
      }
    }
  }
})();
